import { render, staticRenderFns } from "./AktivitasNegatif.vue?vue&type=template&id=3420cc73&scoped=true&lang=html&"
import script from "./AktivitasNegatif.vue?vue&type=script&lang=js&"
export * from "./AktivitasNegatif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420cc73",
  null
  
)

export default component.exports